export default __webpack_public_path__ + "static/media/obj.c05338b7.svg";